// Produktnamn och domän på ett ställe, så att namnet kan bytas utan att leta i koden.
// TILLFÄLLIGT för demo 2026-10-30: visas som "Ferla Energy". Återställ med revert av den här PR:en.
export const PRODUKT = "Ferla Energy";
export const DOMAN = "balanceiq.se";
export const SLOGAN = "Agent för leverantörsfakturor";
// Dit "Boka en genomgång" skickar besökarna. Tom sträng döljer knapparna.
export const KONTAKT = "kontakt@balanceiq.se";
export const KONTAKT_LANK = `mailto:${KONTAKT}?subject=${encodeURIComponent(`Genomgång av ${PRODUKT}`)}`;

// Supabase-projektet "Ferla finance platform". Adressen och den publika nyckeln är gjorda för att
// synas i webbläsaren. Skyddet ligger i inloggningen och RLS. Kan ersättas med VITE_SUPABASE_URL
// och VITE_SUPABASE_PUBLISHABLE_KEY, till exempel för en testdatabas.
export const SUPABASE_URL = "https://ajmqbqvneazpdhrclbdq.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_TVL0TBzRxUiGN7ejyKrlEA_xAGH_81_";
